<template>
  <div class="action-bar" @click="$emit('click')">
    <slot name="icon">
      <svg-icon :name="iconName" class-name="action-icon" />
    </slot>

    <span class="action-bar-title">{{ title }}</span>

    <md-icon name="arrow-right" size="lg" />
  </div>
</template>

<script>
import { Icon } from 'mand-mobile'
export default {
  name: 'ActionBar',

  components: {
    [Icon.name]: Icon
  },

  props: {
    iconName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 46px 24px;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  .action-icon {
    height: 64px;
    width: 64px;
  }

  + .action-bar {
    margin-top: 40px;
  }

  .action-bar-title {
    color: #333;
    font-size: 32px;
    text-align: left;
    flex: 1;
    padding-left: 24px;
  }
}
</style>
